import { Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map, pluck } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
// Models
import { PTU } from 'src/app/business/models/PTU';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
// Queries
import { PTUQuery } from 'src/app/business/queries/ptu.query';
// Services
import { HelpersService } from 'src/app/shared/services/helpers.services';
import { setPageTitle } from 'src/app/shared/utilities/utils';
import { MetatagsService } from 'src/app/shared/services/metatags.service';
import { CanonicalRoutesService } from 'src/app/shared/services/canonical-routes.service';

@Component({
  selector: 'app-ptu',
  templateUrl: './ptu.component.html',
  styleUrls: ['./ptu.component.scss']
})
export class PTUComponent implements OnInit, OnDestroy {
  public pageData: PTU;

  // Breadcrumbs
  public pages: Breadcrumbs[];
  public allowDisclaimer = true;

  private appEnvironment: string;

  constructor(
    private ptuQuery: PTUQuery,
    private route: ActivatedRoute,
    private helpers: HelpersService,
    private app: AppService,
    private metaTags: MetatagsService,
    private canonical: CanonicalRoutesService,
    private router : Router
  ) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.loadPTU(params);
    });
    let currentRoute = this.router.url
    if([
      '/empresas/ptu/adelanto-nomina-empresa',
      '/empresas/ptu/tarjeta_digital_de_incentivos',
      '/empresas/ptu/credito-pymes'
      ].includes(currentRoute)){this.allowDisclaimer = false}
    this.canonical.setCanonicalRoute();
  }

  ngOnDestroy(): void {
    this.metaTags.removeMetaTags(this.pageData.metaDescripciones);
  }

  private loadPTU(params: Params): void {
    this.ptuQuery
      .watch({
        friendlyId: params[this.helpers.propertyOf<PTU>('friendlyId')]
      })
      .valueChanges.pipe(
        pluck('data', 'pTUs'),
        map(r => r[0])
      )
      .subscribe((response: PTU) => {
        if (!response) { this.helpers.redirectTo404(); return; }
        this.pageData = response;
        this.pageData.link = (response.tyCSelector === 'Asset') ? response.tyc.url : (response.tyCSelector === 'Link_Externo') ? 'https://' + response.linkTyC : null;
        const titleElement = document.querySelector('title');
        setPageTitle(titleElement, this.pageData.nombrePublico);

        this.metaTags.setMetaTags(response.metaDescripciones);

        this.pages = [
          { page: 'Empresas', route: '/empresas', isActive: false },
          { page: this.pageData.nombrePublico, isActive: true }
        ];
      });
  }
}
